import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  useEffect(() => {
    document.body.style.overflow = isMobileMenuOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [isMobileMenuOpen]);

  return (
    <>
      <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
        <div className="header-container">
          <Link to="/" className="logo">
            <span className="logo-text">YANX</span>
          </Link>

          <div className="desktop-nav">
            <Link to="/" className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}>Home</Link>
            <Link to="/products" className={`nav-link ${location.pathname === '/products' ? 'active' : ''}`}>Products</Link>
            <Link to="/contact" className={`nav-link ${location.pathname === '/contact' ? 'active' : ''}`}>Contact</Link>
          </div>

          <button
            className="mobile-menu-toggle"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle menu"
          >
            <span className={`hamburger ${isMobileMenuOpen ? 'open' : ''}`}>
              <span></span>
              <span></span>
              <span></span>
            </span>
          </button>
        </div>
      </header>

      {/* Mobile menu rendered at root level, outside header */}
      {isMobileMenuOpen && (
  <div className="mobile-nav-overlay">
    <div className="mobile-nav-header">
      <span className="mobile-nav-logo">YANX</span>
      <button
        className="mobile-nav-close"
        onClick={() => setIsMobileMenuOpen(false)}
        aria-label="Close menu"
      >
        ✕
      </button>
    </div>

    <nav className="mobile-nav-links">
      <Link to="/" className={`mobile-nav-link ${location.pathname === '/' ? 'active' : ''}`}>
        <span className="mobile-nav-num">01</span>
        Home
      </Link>
      <Link to="/products" className={`mobile-nav-link ${location.pathname === '/products' ? 'active' : ''}`}>
        <span className="mobile-nav-num">02</span>
        Products
      </Link>
      <Link to="/contact" className={`mobile-nav-link ${location.pathname === '/contact' ? 'active' : ''}`}>
        <span className="mobile-nav-num">03</span>
        Contact
      </Link>
    </nav>

    <div className="mobile-nav-footer">
      <span>Premium Men's Essentials</span>
    </div>
  </div>
)}
    </>
  );
};

export default Header;